import Text from "./Text";
import Unit from "./Unit";
import Date from "./Date";
import Select from "./Select";
import ButtonInputGroup from "./ButtonInputGroup";

export default {
  Text,
  Unit,
  Date,
  Select,
  ButtonInputGroup
};



// WEBPACK FOOTER //
// ./src/Core/Components/Inputs/index.js